import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { conversationalRoutingCacheKeys } from "./constants";
import type { ConversationalRoutingResult, PutConversationalRoutingProps } from "./types";

export const putConversationalRouting = reactQueryMutationAdapter(
  conversationalRoutingCacheKeys,
  (props: PutConversationalRoutingProps): Promise<ConversationalRoutingResult> => {
    return fetch(`/${props.appGroupId}/conversational/routing`, "PUT", {
      brand_guideline_id: props.brandGuidelineId,
      chat_setting: props.chatSetting,
    });
  }
);
